import React, { Component } from 'react';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';

class MonitorSessionClosedNotification extends Component {
    render() {
        const { show, t } = this.props;

        return (
            <Modal show={show} onHide={this.props.hideModal} size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FontAwesomeIcon icon={duotone("triangle-exclamation")} />{this.props.t("dashboard")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>{this.props.t("sessionclosedmessage")}</Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.props.reconnect}>{this.props.t("reconnect")}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withTranslation()(MonitorSessionClosedNotification);